<template>
  <div class="log-detail">
    <el-page-header @back="goBack" content="日志详情"></el-page-header>
    <el-row class="mar">
      <el-col :span="6">新增时间：{{info.startTime}}</el-col>
      <el-col :span="6">途径：{{info.channel}}</el-col>
       <el-col :span="6">数据来源：{{info.source}}</el-col>
    </el-row>
    <el-row class="mar-b skuBtns">
      <el-button @click="handleSku('')"  :type="isSku != 'sku' ? 'primary' : 'default'" style="margin-right:0">按款式</el-button>
      <el-button @click="handleSku('sku')"  :type="isSku == 'sku' ? 'primary' : 'default'" style="margin-left:0">按sku</el-button>
    </el-row>
    <el-tabs v-model="activeName">
      <el-tab-pane label="全部" name="all">
        <span slot="label">全部（{{info.total || 0}}）</span>
        <Table :tableHeight='350' @edit="handleEdit"  :list="allList" :info="info" :isSku="isSku" />
      </el-tab-pane>
      <el-tab-pane label="成功" name="sucess">
        <span slot="label">成功（{{info.successTotal || 0}}）</span>
        <Table :tableHeight='350' @edit="handleEdit" :list="allList" :info="info" :isSku="isSku" />
      </el-tab-pane>
      <el-tab-pane label="失败" name="fail">
        <span slot="label">失败（{{info.failureTotal || 0}}）</span>
        <Table :tableHeight='350' @edit="handleEdit" :list="allList" :info="info" :isSku="isSku" />
      </el-tab-pane>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageInfoData.pageNo"
          :page-sizes="[5,10,20,50,100,200,500]"
          :page-size="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfoData.total">
        </el-pagination>
    </el-tabs>
    <!-- 编辑窗口 -->
    <EditDialog ref="editDialog" />
  </div>
</template>

<script>
import Table from './table.vue'
import EditDialog from "@/components/prod/center/dialogs/EditDialog.vue";
import { getOperatorLogDetail, getOperatorSkuLogDetail } from '@servers/prod/log/index'
import { mapGetters, mapActions} from 'vuex'
import { getGoodsBaseInfo } from '@servers/prod/center/index'

export default {
  components: {
    Table,
    EditDialog,
  },
  props: ['id'],
  data() {
    return {
      activeName: 'all',
      list: [],
      info: '',
      subCode: '',
      isSku: '',
      pageInfoData:{
        total: 0,
        pageSize: 5,
        pageNo: 1,
      },
    }
  },
  watch:{
    activeName: {
        handler(newData) {
            if (newData) {
                this.pageInfoData.pageNo = 1
                this.fetch_detail();
            }
        },
        deep: true,
    },
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    allList() {
      return this.list
    },
    // sucessList() {
    //   return this.list.filter(item => (item.status == 1 || item.status == 2))
    // },
    // failList() {
    //   return this.list.filter(item => item.status == 0)
    // }
  },

  methods: {
    handleSizeChange(val) {
      this.pageInfoData.pageSize = val
      this.fetch_detail()
    },
    handleCurrentChange(val) {
      this.pageInfoData.pageNo = val
      this.fetch_detail()
    },
    handleSku(type) {
      this.activeName = 'all';
      this.isSku = type
      if(type == 'sku') {
        this.fetch_operatorSkuLogDetail()
      } else {
        this.list = []
        this.info = ''
        this.fetch_operatorLogDetail()
      }
    },
    fetch_detail(){
      const type = this.isSku
      if(type == 'sku') {
        this.fetch_operatorSkuLogDetail()
      } else {
        this.list = []
        this.info = ''
        this.fetch_operatorLogDetail()
      }
    },
    goBack() {
      this.$router.back();
      // this.$router.replace({
      //   name: `${this.routerPrefix}prod_log`
      // })
    },
    async fetch_operatorLogDetail() {
      const { pageNo, pageSize } = this.pageInfoData
      const activeNameMap = new Map([
        ['all',''],
        ['sucess','1'],
        ['fail','0'],
      ])
      const _status = activeNameMap.get(this.activeName)
      const params = {
        id: this.id,
        pageNo,
        pageSize,
        status: _status || ''
      }
      const res = await getOperatorLogDetail(params);
      if(!res) return;
      this.list = res.list || [];
      this.info = res.info || {};
      this.pageInfoData = {
        pageNo: res?.pageNo || 1,
        pageSize: res?.pageSize || 5,
        total: res?.total || 0,
      }
    },
    async fetch_operatorSkuLogDetail() {
      this.list = [];
      this.info = '';
      const { pageNo, pageSize } = this.pageInfoData
      const activeNameMap = new Map([
        ['all',''],
        ['sucess','0'],
        ['fail','1'],
      ])
      const _status = activeNameMap.get(this.activeName)
      const params = {
        id: this.id,
        pageNo,
        pageSize,
        status: _status || ''
      }
      const res = await getOperatorSkuLogDetail(params);
      if(!res) return;
      this.list = res.skuList || [];
      this.info = res.info  || {};
      this.pageInfoData = {
        pageNo: res?.pageNo || 1,
        pageSize: res?.pageSize || 5,
        total: res?.total || 0,
      }
    },
    async handleEdit(baseItemId){
      const res = await getGoodsBaseInfo(baseItemId);
      if(!res) return this.$message.error('编辑商品失败：当前商品已从分销商品中移除；');
      this.$refs.editDialog.method_open(res, {isDistributor:true, publishEntrance: 1});
    }

  },
  mounted() {
    if(this.id) {
      this.fetch_operatorLogDetail()
    }
  }

}
</script>

<style lang="scss" scoped>
.mar {
  margin:20px 0;
}

</style>
